import { render, staticRenderFns } from "./tdItem.vue?vue&type=template&id=087d57a7&"
import script from "./tdItem.vue?vue&type=script&lang=js&"
export * from "./tdItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tdItem.vue"
export default component.exports